export const visit = (vm, at) => {
at({ "en": { "channel-settings": { "send-from-address": { "use-default": "Use default", "custom": "Customize from address", "email-placeholder": "example@email.com" } } } });
};